import { CrmOrganizationUnitFeaturePage } from "..";

/** 组织单元维护页面。 */
export function CrmOrganizationUnitPage() {
  return <CrmOrganizationUnitFeaturePage />;
}
